export const bgLightness = (colorStr, alpha) => {
  const {r, g, b} = colorToRgb(colorStr, alpha);

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) return 'light';
  return 'dark';
};

export const colorToRgb = (colorStr, a) => {
  const ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = colorStr;
  let color = `${ctx.fillStyle}`;
  color = +`0x${color.slice(1)}`;

  const RGBA = {
    red: color >> 16,
    green: (color >> 8) & 255,
    blue: color & 255,
    alpha: a,
  };
  const alpha = 1 - RGBA.alpha;
  return {
    r: Math.round((RGBA.alpha * (RGBA.red / 255) + alpha * (255 / 255)) * 255),
    g: Math.round((RGBA.alpha * (RGBA.green / 255) + alpha * (255 / 255)) * 255),
    b: Math.round((RGBA.alpha * (RGBA.blue / 255) + alpha * (255 / 255)) * 255),
  };
};
